import { Session } from '@ais-ui/auth';

export type Selectable = {
  id: number;
  name: string;
};

export const getSelectables = async (
  session: Session,
  thing: string
): Promise<Selectable[]> => {
  const response = await session.request('getList', { thing: thing });

  if (!response) {
    return [];
  }

  return response;
};
